/**
 * The Security Center, assembled: its pages (tokens resolved, bodies parsed
 * with the Help Center's Markdown), the author and lookups.
 *
 * Pure and Node-importable (relative imports only): the pages read it, and
 * so does the build-time pre-renderer that writes static HTML and the
 * sitemap (scripts/prerender-help.mjs).
 */
import { SECURITY_PAGES, SECURITY_HIGHLIGHTS, SECURITY_PAGES_UPDATED } from './pages.js';
import { getAuthor } from '../help/authors.js';
import { parseMarkdown, toPlainText } from '../help/markdown.js';
import { resolveTokens } from '../help/tokens.js';

export const SECURITY_BASE_PATH = '/security';
export const SECURITY_SITE_ORIGIN = 'https://defera.app';
export const SECURITY_AUTHOR_ID = 'silas';
export const SECURITY_TXT_PATH = '/.well-known/security.txt';

export const securityPagePath = (slug) => `${SECURITY_BASE_PATH}/${slug}`;

export function buildSecurityCenter() {
  const author = getAuthor(SECURITY_AUTHOR_ID);
  const pages = SECURITY_PAGES.map((raw) => {
    const body = resolveTokens(raw.body);
    const { blocks, headings } = parseMarkdown(body);
    return {
      ...raw,
      title: resolveTokens(raw.title),
      summary: resolveTokens(raw.summary),
      id: raw.slug,
      path: securityPagePath(raw.slug),
      authorProfile: author,
      body,
      blocks,
      headings,
      plainText: toPlainText(blocks),
    };
  });
  const bySlug = new Map(pages.map((p) => [p.slug, p]));
  return {
    pages,
    highlights: SECURITY_HIGHLIGHTS,
    author,
    updated: SECURITY_PAGES_UPDATED,
    getPage: (slug) => bySlug.get(slug) || null,
  };
}

export const SECURITY_CENTER = buildSecurityCenter();
